import { inject, Injectable } from "@angular/core";
import { Translation, TranslocoLoader } from "@jsverse/transloco";
import { HttpClient } from "@angular/common/http";
import { forkJoin, map } from "rxjs";
import { merge } from "lodash-es";

@Injectable({ providedIn: "root" })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string) {
    return forkJoin([
      this.http.get<Translation>(`/assets/i18n/${lang}.json`),
      this.http.get<Translation>(`/assets/i18n/extra_${lang}.json`),
    ]).pipe(
      map(([base, whitelabel]) => merge(base, whitelabel)),
    );
  }
}
